module.exports = __webpack_public_path__ + "img/n_logo1@2x.3e04d65a.png";